import { ReactElement } from 'react';
import { InfoPage } from '../../pages/AppInfo/index';
import { AssetCreate, AssetDetail, AssetPage } from '../../pages/Asset/index';
import { BrowseOpcUa } from '../../pages/BrowseOpcUa';
import { DashboardCreate, DashboardDetail } from '../../pages/Dashboard/index';
import { EmailReportCreate, EmailReportDetail, EmailReportPage } from '../../pages/EmailReport';
import { EmailReportAssetCreate } from '../../pages/EmailReportAsset/index';
import { EmailReportUserCreate } from '../../pages/EmailReportUser/index';
import { GroupCreate, GroupDetail, GroupPage } from '../../pages/Group';
import { HomePage } from '../../pages/Home/HomePage';
import { LocalUserCreate, LocalUserPage } from '../../pages/LocalUser';
import { LocalUserDetail } from '../../pages/LocalUser/LocalUserDetail';
import { LoginPage } from '../../pages/Login/LoginPage';
import { LogoutPage } from '../../pages/Logout/LogoutPage';
import { MonitoredCounterCreate, MonitoredCounterDetail } from '../../pages/MonitoredCounter';
import {
  MonitoredCounterScrapCreate,
  MonitoredCounterScrapDetail,
} from '../../pages/MonitoredCounterScrap';
import { MonitoredCycleTimeCreate, MonitoredCycleTimeDetail } from '../../pages/MonitoredCycleTime';
import {
  MonitoredProcessDataCreate,
  MonitoredProcessDataDetail,
} from '../../pages/MonitoredProcessData';
import { MonitoredStateCreate, MonitoredStateDetail } from '../../pages/MonitoredState';
import { OpcClientCreate, OpcClientDetail, OpcClientPage } from '../../pages/OpcClient/index';
import {
  PerformanceCommentCategoryCreate,
  PerformanceCommentCategoryDetail,
} from '../../pages/PerformanceCommentCategory';
import { PermissionCreate, PermissionPage } from '../../pages/Permission/index';
import { ShiftCreate, ShiftDetail, ShiftPage } from '../../pages/Shift/index';

interface AppRoute {
  path: string;
  component: ReactElement;
}

export const paths = {
  HOME: '/',
  LOGIN_PAGE: 'login',
  LOGOUT_PAGE: 'logout',
  APP_INFO: 'appInfo',
  // Assets
  ASSETS_LIST: '/assets',
  ASSETS_CREATE: '/assets/create',
  ASSETS_DETAIL: '/assets/detail',
  SHIFT_TO_ASSET: '/add-shift',
  // Monitored counter
  MONITORED_COUNTER_CREATE: '/counter/create',
  MONITORED_COUNTER_DETAIL: '/counter/detail',
  MONITORED_COUNTER_SCRAP_CREATE: '/counter-scrap/create',
  MONITORED_COUNTER_SCRAP_DETAIL: '/counter-scrap/detail',
  MONITORED_CYCLE_TIME_CREATE: '/cycle-time/create',
  MONITORED_CYCLE_TIME_DETAIL: '/cycle-time/detail',
  MONITORED_PROCESS_DATA_CREATE: '/process-data/create',
  MONITORED_PROCESS_DATA_DETAIL: '/process-data/detail',
  MONITORED_STATE_DETAIL: '/state/create',
  MONITORED_STATE_CREATE: '/state/detail',
  // Opc clients
  OPCCLIENT_LIST: '/opc-clients',
  OPCCLIENT_CREATE: '/opc-clients/create',
  OPCCLIENT_DETAIL: '/opc-clients/detail',
  // Shifts
  SHIFTS_LIST: '/shifts',
  SHIFTS_CREATE: '/shifts/create',
  SHIFTS_DETAIL: '/shifts/detail',
  // Dashboards
  DASHBOARDS_LIST: '/dashboards',
  DASHBOARDS_CREATE: '/dashboard-create',
  DASHBOARDS_DETAIL: '/dashboard-detail',
  // LocalUser
  LOCAL_USER: '/localUser',
  LOCAL_USER_CREATE: '/localUser/create',
  LOCAL_USER_DETAIL: '/localUser/detail',
  // Permissions
  PERMISSION: '/permission',
  PERMISSION_CREATE: '/permission/create',
  // Groups
  GROUP_LIST: '/groups',
  GROUP_CREATE: '/group/create',
  GROUP_DETAIL: '/group/detail',
  // Email reports
  EMAIL_REPORT_LIST: '/email-reports',
  EMAIL_REPORT_CREATE: '/email-reports/create',
  EMAIL_REPORT_DETAIL: '/email-reports/detail',
  // Email reports asset
  EMAIL_REPORT_ASSET_CREATE: '/asset-report/create',
  EMAIL_REPORT_ASSET_DETAIL: '/asset-report/detail',
  // Email reports user
  EMAIL_REPORT_USER_CREATE: '/user-report/create',
  EMAIL_REPORT_USER_DETAIL: '/user-report/detail',
  // performance comment category
  PERFORMANCE_COMMENT_CATEGORY_LIST: '/performance-comment-category',
  PERFORMANCE_COMMENT_CATEGORY_CREATE: '/performance-comment-category-create',
  PERFORMANCE_COMMENT_CATEGORY_DETAIL: '/performance-comment-category-detail',
  // Browse OPC UA
  BROWSE_OPC_UA: '/browse-opc/',
};

export const routes: AppRoute[] = [
  {
    path: paths.HOME,
    component: <HomePage />,
  },
  {
    path: paths.LOGIN_PAGE,
    component: <LoginPage />,
  },
  {
    path: paths.LOGOUT_PAGE,
    component: <LogoutPage />,
  },
  {
    path: paths.ASSETS_LIST,
    component: <AssetPage />,
  },
  {
    path: `${paths.ASSETS_DETAIL}/:id`,
    component: <AssetDetail />,
  },
  {
    path: `${paths.ASSETS_CREATE}/:parentAssetId`,
    component: <AssetCreate />,
  },
  {
    path: paths.ASSETS_CREATE,
    component: <AssetCreate />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_COUNTER_CREATE}`,
    component: <MonitoredCounterCreate />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_COUNTER_DETAIL}/:id`,
    component: <MonitoredCounterDetail />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_COUNTER_SCRAP_CREATE}`,
    component: <MonitoredCounterScrapCreate />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_COUNTER_SCRAP_DETAIL}/:id`,
    component: <MonitoredCounterScrapDetail />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_CYCLE_TIME_CREATE}`,
    component: <MonitoredCycleTimeCreate />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_CYCLE_TIME_DETAIL}/:id`,
    component: <MonitoredCycleTimeDetail />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_PROCESS_DATA_CREATE}`,
    component: <MonitoredProcessDataCreate />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_PROCESS_DATA_DETAIL}/:id`,
    component: <MonitoredProcessDataDetail />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_STATE_CREATE}`,
    component: <MonitoredStateCreate />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId${paths.MONITORED_STATE_DETAIL}/:id`,
    component: <MonitoredStateDetail />,
  },
  {
    path: paths.OPCCLIENT_LIST,
    component: <OpcClientPage />,
  },
  {
    path: `${paths.OPCCLIENT_DETAIL}/:id`,
    component: <OpcClientDetail />,
  },
  {
    path: paths.OPCCLIENT_CREATE,
    component: <OpcClientCreate />,
  },
  {
    path: paths.SHIFTS_LIST,
    component: <ShiftPage />,
  },
  {
    path: `${paths.SHIFTS_DETAIL}/:id`,
    component: <ShiftDetail />,
  },
  {
    path: paths.SHIFTS_CREATE,
    component: <ShiftCreate />,
  },
  {
    path: `${paths.ASSETS_DETAIL}/:parentId${paths.DASHBOARDS_DETAIL}/:id`,
    component: <DashboardDetail />,
  },
  {
    path: `${paths.ASSETS_DETAIL}/:parentId${paths.DASHBOARDS_CREATE}`,
    component: <DashboardCreate />,
  },
  {
    path: `${paths.ASSETS_DETAIL}/:parentId${paths.PERFORMANCE_COMMENT_CATEGORY_DETAIL}/:id`,
    component: <PerformanceCommentCategoryDetail />,
  },
  {
    path: `${paths.ASSETS_DETAIL}/:parentId${paths.PERFORMANCE_COMMENT_CATEGORY_CREATE}`,
    component: <PerformanceCommentCategoryCreate />,
  },
  {
    path: paths.LOCAL_USER,
    component: <LocalUserPage />,
  },
  {
    path: paths.LOCAL_USER_CREATE,
    component: <LocalUserCreate />,
  },
  {
    path: `${paths.LOCAL_USER_DETAIL}/:id`,
    component: <LocalUserDetail />,
  },
  {
    path: paths.PERMISSION,
    component: <PermissionPage />,
  },
  {
    path: paths.PERMISSION_CREATE,
    component: <PermissionCreate />,
  },
  {
    path: paths.GROUP_LIST,
    component: <GroupPage />,
  },
  {
    path: `${paths.GROUP_DETAIL}/:id`,
    component: <GroupDetail />,
  },
  {
    path: paths.GROUP_CREATE,
    component: <GroupCreate />,
  },
  {
    path: paths.EMAIL_REPORT_LIST,
    component: <EmailReportPage />,
  },
  {
    path: `${paths.EMAIL_REPORT_DETAIL}/:id`,
    component: <EmailReportDetail />,
  },
  {
    path: paths.EMAIL_REPORT_CREATE,
    component: <EmailReportCreate />,
  },
  {
    path: `${paths.EMAIL_REPORT_LIST}/:parentId${paths.EMAIL_REPORT_ASSET_CREATE}`,
    component: <EmailReportAssetCreate />,
  },
  {
    path: `${paths.EMAIL_REPORT_LIST}/:parentId${paths.EMAIL_REPORT_USER_CREATE}`,
    component: <EmailReportUserCreate />,
  },
  {
    path: paths.BROWSE_OPC_UA,
    component: <BrowseOpcUa />,
  },
  {
    path: paths.APP_INFO,
    component: <InfoPage />,
  },
];
